import React, { useState } from 'react';
import { Check, ArrowRight, Lock, Zap, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
type PackId = 'inicial' | 'full';
const CHECKOUT_URLS: Record<PackId, string> = {
  inicial: 'https://checkout.saberclick.com/cart/50365179297985:1',
  full: 'https://checkout.saberclick.com/cart/50365179396289:1'
};
const PACKS: {
  id: PackId;
  name: string;
  tagline: string;
  oldPrice: string;
  price: string;
  highlight: boolean;
}[] = [{
  id: 'inicial',
  name: 'PACK INICIAL',
  tagline: '6 tomos',
  oldPrice: '$29.990',
  price: '$19.990',
  highlight: false
}, {
  id: 'full',
  name: 'PACK FULL',
  tagline: '6 tomos + 6 bonus',
  oldPrice: '$39.990',
  price: '$29.990',
  highlight: true
}];
interface OfferSelectorProps {
  variant?: 'light' | 'dark';
}
export function OfferSelector({
  variant = 'light'
}: OfferSelectorProps) {
  const [selected, setSelected] = useState<PackId>('full');
  const isDark = variant === 'dark';
  return <div className="max-w-2xl mx-auto" data-id="element-137">
      <div className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-138">
        {PACKS.map(pack => {
        const isSelected = selected === pack.id;
        return <button key={pack.id} type="button" onClick={() => setSelected(pack.id)} aria-pressed={isSelected} className={`relative text-left rounded-2xl border-2 p-4 md:p-5 transition-all focus:outline-none focus:ring-2 focus:ring-brand-400 ${isSelected ? 'border-brand-500 shadow-lg shadow-brand-500/20 ' + (isDark ? 'bg-slate-800' : 'bg-brand-50') : isDark ? 'border-slate-700 bg-slate-800/40 hover:border-slate-600' : 'border-slate-200 bg-white hover:border-slate-300'}`} data-id="element-139">
              {pack.highlight && <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-accent-500 to-accent-600 text-white text-[10px] md:text-xs font-bold px-2.5 py-0.5 rounded-full shadow whitespace-nowrap" data-id="element-140">
                  ⭐ MÁS ELEGIDO
                </span>}

              {/* Radio indicator */}
              <div className="flex items-center justify-between mb-2 mt-1" data-id="element-141">
                <h3 className={`text-sm md:text-base font-extrabold ${isDark ? 'text-white' : 'text-slate-900'}`} data-id="element-142">
                  {pack.name}
                </h3>
                <span className={`w-4 h-4 md:w-5 md:h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${isSelected ? 'border-brand-500 bg-brand-500' : isDark ? 'border-slate-500' : 'border-slate-300'}`} data-id="element-143">
                  {isSelected && <Check className="w-2.5 h-2.5 md:w-3 md:h-3 text-white" strokeWidth={3} data-id="element-144" />}
                </span>
              </div>

              <p className={`text-[11px] md:text-xs mb-3 leading-snug ${isDark ? 'text-slate-400' : 'text-slate-500'}`} data-id="element-145">
                {pack.tagline}
              </p>

              <div className="flex items-baseline gap-1.5 flex-wrap" data-id="element-146">
                <span className={`text-xs line-through ${isDark ? 'text-slate-500' : 'text-slate-400'}`} data-id="element-147">
                  {pack.oldPrice}
                </span>
                <span className={`text-xl md:text-2xl font-black ${isDark ? 'text-white' : 'text-slate-900'}`} data-id="element-148">
                  {pack.price}
                </span>
              </div>
            </button>;
      })}
      </div>

      {/* Shared CTA */}
      <motion.a key={selected} href={CHECKOUT_URLS[selected]} initial={{
      scale: 0.98
    }} animate={{
      scale: 1
    }} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.97
    }} className="mt-4 md:mt-5 w-full py-4 px-6 rounded-xl bg-brand-600 hover:bg-brand-500 text-white font-bold text-base md:text-lg shadow-lg shadow-brand-600/30 transition-colors flex items-center justify-center gap-2" data-id="element-149">
        {selected === 'full' ? 'SÍ, QUIERO EL PACK FULL' : 'QUIERO EL PACK INICIAL'}
        <ArrowRight className="w-5 h-5" data-id="element-150" />
      </motion.a>

      <div className={`flex flex-wrap justify-center gap-3 md:gap-5 mt-4 text-[11px] md:text-sm font-medium ${isDark ? 'text-slate-400' : 'text-slate-500'}`} data-id="element-151">
        <span className="flex items-center gap-1" data-id="element-152">
          <Lock className="w-3.5 h-3.5" data-id="element-153" /> Pago seguro
        </span>
        <span className="flex items-center gap-1" data-id="element-154">
          <Zap className="w-3.5 h-3.5" data-id="element-155" /> Acceso en 5 min
        </span>
        <span className="flex items-center gap-1" data-id="element-156">
          <ShieldCheck className="w-3.5 h-3.5" data-id="element-157" /> Garantía 7 días
        </span>
      </div>
    </div>;
}